import $ from 'jquery'
// @ts-ignore
window.jQuery = window.$ = $;

require("@fancyapps/fancybox");



